import {
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import HistoryStyle from "./HistoryStyle.module.scss";
import BillingStatus from "../../Components/BillingStatus/BillingStatus";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ReplyIcon from "@mui/icons-material/Reply";
function BillingHistory(props) {
  const { data } = props;
  const navigate = useNavigate();
  function downloadReceipt(cleanedData) {
    window.open(cleanedData, "_blank");
  }
  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg
  );
  const params = useParams();
  let orgId = parseInt(params.orgId);

  const orgCountry = selectedOrg?.country;
  let dataStatus = false;

  if (data?.length > 0) {
    dataStatus = true;
  }

  return (
    <>
      <TableContainer className={HistoryStyle.TableContainer}>
        <Table>
          <TableHead className={HistoryStyle.header}>
            <TableCell className={HistoryStyle.headerLabel}>
              Invoice ID
            </TableCell>
            <TableCell className={HistoryStyle.headerLabel}>
              Description
            </TableCell>
            <TableCell className={HistoryStyle.headerLabel}>
              Billing Date
            </TableCell>
            <TableCell className={HistoryStyle.headerLabel}>Amount</TableCell>
            <TableCell className={HistoryStyle.headerLabel}>Status</TableCell>
            <TableCell className={HistoryStyle.headerLabel}>View</TableCell>
          </TableHead>
          <TableBody>
            {dataStatus &&
              data.map((item, index) => (
                <TableRow key={index} className={HistoryStyle.tableRow}>
                  <TableCell className={HistoryStyle.bodyLabel}>
                    <span className={HistoryStyle.invoiceId}>
                      {item.invoiceId}
                    </span>
                  </TableCell>
                  <TableCell className={HistoryStyle.bodyLabel}>
                    {item?.description}
                  </TableCell>
                  <TableCell className={HistoryStyle.bodyLabel}>
                    {item?.billingDate}
                  </TableCell>
                  <TableCell className={HistoryStyle.bodyLabel}>
                    {item?.amount}
                  </TableCell>
                  <TableCell className={HistoryStyle.bodyLabel}>
                    <BillingStatus status={item?.status} />
                  </TableCell>
                  <TableCell
                    className={HistoryStyle.download}
                    onClick={() => {
                      if (orgCountry === "USA") {
                        downloadReceipt(item?.hostedInvoiceUrl);
                      } else {
                        navigate(`/account/${orgId}/invoice`, {
                          state: { invoiceHistory: item },
                        });
                      }
                    }}
                  >
                    <Grid2 className={HistoryStyle.ReplyIcon}>
                      <ReplyIcon />
                    </Grid2>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        {!dataStatus && (
          <Grid2 className={HistoryStyle.noData}>
            <Grid2 className={HistoryStyle.data}>
              No billing history available
            </Grid2>
          </Grid2>
        )}
      </TableContainer>
    </>
  );
}

export default BillingHistory;
